import { fromEvent, Observable } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { ContentEditableElement } from '../../editors/base/contentEditableEditor';
import { eventHasMetaKeyForPlatform } from '../../helpers/platform/modifierKeyHelpers';
import { Service } from '../base/service';
import { createElementEffectService } from './elementService';

const STYLE_KEYS = new Set(['b', 'i', 'u']);

export type ContentEditableResetServiceOptions = {
  shouldPreventDefaultStyleKeyboardShortcuts?: boolean;
};

export function createContentEditableResetService(
  element$: Observable<ContentEditableElement | null>,
  options: ContentEditableResetServiceOptions = {},
): Service {
  return createElementEffectService(element$, element =>
    fromEvent<KeyboardEvent>(element, 'keydown').pipe(
      tap(event => {
        // Note: we've seen cases of event.key being undefined.
        const key = event.key ? event.key.toLowerCase() : '';

        // Disable default style keyboard shortcuts.
        if (
          options.shouldPreventDefaultStyleKeyboardShortcuts &&
          eventHasMetaKeyForPlatform(event) &&
          STYLE_KEYS.has(key)
        ) {
          event.preventDefault();
        }
      }),
      share(),
    ),
  );
}
